import { parse } from "qs";
import { useMemo } from "react";
import { useLocation } from 'react-router-dom';

const useQueryString = <T extends string | number | symbol>(values: { key: T, names: string[] }[], queryString?: string): Record<T, string | undefined> => {
    const location = useLocation();
    
    return useMemo(() => {
        const parsedQs = parse(queryString ?? location.search, { ignoreQueryPrefix: true }) as Record<string, string | undefined>;

        const output: Record<T, string | undefined> = {} as Record<T, string | undefined>; 

        const parsedQsKeys = Object.keys(parsedQs);

        for (let value of values) {
            for (let name of value.names) {
                if (output[value.key]) {
                    continue;
                }

                const lowerName = name.toLowerCase();
                const qsKeys = parsedQsKeys.filter(x => x.toLowerCase() === lowerName);

                for (let key of qsKeys) {
                    if (output[value.key]) {
                        continue;
                    }
                    
                    if (!parsedQs[key]) {
                        continue;
                    }
    
                    output[value.key] = parsedQs[key];
                }
            }
        }

        return output;
    }, [values, location, queryString])
}

export default useQueryString;